import axios from "axios";
// import {getSelfToken} from '../../_helpers/auth/secureToken'
import { connectWithSpotifyArtist } from "../_constants/api.constant";
export async function connectWithSpotify(postData){
    const response=await axios.post(
        connectWithSpotifyArtist.FETCH_SPOTIGY_ARTIST_DETAIL,
       postData,
        {
            /* headers:{
                Authorization: 'Token '+getSelfToken(),
            }, */
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}